import request from '../utils/request';
export function loadUsers(filters = {}) {
    const normalizedFilters = { ...filters };
    if (typeof normalizedFilters.search === 'string') {
        const trimmedSearch = normalizedFilters.search.trim();
        if (trimmedSearch) {
            normalizedFilters.search = trimmedSearch;
        }
        else {
            delete normalizedFilters.search;
        }
    }
    return request().query(normalizedFilters).get('/api/v1/users/').send();
}
export function getUser(userId) {
    return request().get(`/api/v1/users/${userId}/`).send();
}
export function createUser(userData) {
    return request().post('/api/v1/users/').send(userData);
}
export function updateUser(userId, userData) {
    return request().patch(`/api/v1/users/${userId}/`).send(userData);
}
export function deleteUser(userId) {
    return request().delete(`/api/v1/users/${userId}/`).send();
}
export function loadClinicUsers(filters = {}) {
    return request().query(filters).get("/api/v1/clinic-users/").send();
}
export function sendPasswordReset(userId) {
    return request().post(`/api/v1/users/${userId}/send-password-reset/`).send();
}
export function resendVerificationEmail(userId) {
    return request().post(`/api/v1/users/${userId}/resend-verification-email/`).send();
}
export function sendContactRequest(name, email, message) {
    return request().post("/api/v1/contact-us/").send({
        name, email, message
    });
}
